import { handleActions } from 'redux-actions';

import { CAPS } from '../constants';

const salesTeamInfos = [
  {
    countryKey: 'AT',
    url: 'https://www.klarna.com/at/verkaeufer/jetzt-starten/',
    email: 'vertrieb@klarna.com',
  },
  {
    countryKey: 'BE',
    url: 'https://www.klarna.com/be/zakelijk/bel-me/',
    email: 'sales.be@klarna.com',
  },
  {
    countryKey: 'DE',
    url: 'https://www.klarna.com/de/verkaeufer/jetzt-starten/',
    email: 'vertrieb@klarna.com',
  },
  {
    countryKey: 'FI',
    url: 'https://www.klarna.com/fi/yritys/get-started/',
    email: 'myynti@klarna.com',
  },
  {
    countryKey: 'FR',
    url: 'https://www.klarna.com/fr-be/entreprise/inscrivez-vous/',
    email: '',
  },
  {
    countryKey: 'NL',
    url: 'https://www.klarna.com/nl/zakelijk/bel-me/',
    email: 'verkoop@klarna.com',
  },
  {
    countryKey: 'NO',
    url: 'https://www.klarna.com/no/bedrift/get-started/',
    email: 'salg@klarna.com',
  },
  {
    countryKey: 'SE',
    url: 'https://www.klarna.com/se/foretag/get-started/',
    phone: '08 - 120 120 30',
    email: 'salj@klarna.com',
  },
  {
    countryKey: 'GB',
    url: 'https://www.klarna.com/uk/business/get-started/',
    email: 'sales@klarna.co.uk',
  },
  {
    countryKey: 'US',
    url: 'https://www.klarna.com/us/business/get-started/',
    email: 'klarna.usa@klarna.com',
  },
];

const init = {
  businessConcepts: [],
  countries: [],
  countrySettings: {},
  currencies: [],
  extendedExposure: {},
  organizationCategories: [],
  partnerCountryConfiguration: {},
  paymentIntervals: [],
  productNames: [],
  questionnaires: {},
  registrationCourts: [],
  returnRates: {},
  salesTeamInfos,
  sellingCountries: [],
  stakeholderTypes: [],
  states: [],
};

export default handleActions(
  {
    [CAPS.V2_COUNTRIES_GET]: (state, { error, payload }) => {
      if (error) {
        return state;
      }
      return {
        ...state,
        signupCountries: payload && payload.data ? payload.data : [],
      };
    },
    [CAPS.V2_OPTIONS_GET]: (state, { error, payload }) => {
      if (error) {
        return state;
      }
      return {
        ...state,
        businessConcepts: payload.data.businessConcepts || [],
        countries: payload.data.countries.map(c => ({
          key: c.momaCode,
          data: c,
        })),
        currencies: payload.data.currencies.map(c => ({
          key: c.momaCode,
          data: c,
        })),
        organizationCategories: payload.data.organizationCategories.map(key => ({ key })),
        states: payload.data.states,
        stakeholderTypes: payload.data.stakeholders.stakeholderTypes.map(key => ({ key })),
        countrySettings: {
          DE: {
            registrationCourts: payload.data.countrySettings.DE.REGISTRATION_COURTS.map(rc => ({
              key: rc,
              label: rc,
            })),
          },
        },
        extendedExposure: payload.data.extendedExposure || {},
        partnerCountryConfiguration: payload.data.partnerCountryConfiguration || {},
        paymentIntervals: payload.data.paymentIntervals || [],
        productNames: payload.data.productNames || [],
        questionnaires: payload.data.questionnaires || {},
        returnRates: payload.data.returnRates || {},
        sellingCountries: payload.data.sellingCountries || [],
        countryConfig: payload.data.countryConfig || {},
        regionConfig: payload.data.regionConfig || {},
      };
    },
  },
  init,
);
